import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {BusinessService, OTPCreationRoute} from '@mpt-fo/common/core/services/business.service';
import {LocalStorageService} from '@mpt-fo/common/core/services/local-storage.service';
import {ScreenManagerService} from '@mpt-fo/common/core/services/screen-manager.service';
import {
	PasswordInput,
	PasswordValidatorType,
	PhoneNumberInput
} from '@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component';
import {StorageKeys} from '@mpt-fo/common/shared/models/storage-keys';

@Component({
	selector: 'app-otp-phone-selector',
	templateUrl: './otp-phone-selector.component.html',
	styleUrls: ['./otp-phone-selector.component.scss']
})
export class OtpPhoneSelectorComponent implements OnInit {

	isMobile: any = false;
	phoneNumber: PhoneNumberInput;
	password: PasswordInput;
	fb: FormBuilder;
	form: FormGroup;
	router: Router;
	localStorage: LocalStorageService;
	currentStep = 1;
	readonly PIN_LENGTH = 4;
	loading = true;

	constructor(
		private screenManagerService: ScreenManagerService,
		fb: FormBuilder, router: Router,
		private businessService: BusinessService,
		localStorage: LocalStorageService) {
		this.screenManagerService = screenManagerService;
		this.fb = fb;
		this.router = router;
		this.localStorage = localStorage;
	}


	ngOnInit(): void {
		this.isMobile = this.screenManagerService.isMobile();
		this.screenManagerService.isMobile$.subscribe(isMobile => {
			this.isMobile = isMobile;
		});
	}

	initialize() {
		const otpFormData = this.businessService.getData();
		let businessPhone = this.localStorage.get(StorageKeys.businessNumber);
		businessPhone = businessPhone?.slice(3);
		businessPhone = '0' + businessPhone;
		this.phoneNumber = new PhoneNumberInput(businessPhone || '', 'Phone Number', true);
		this.password = new PasswordInput(otpFormData.password || '', 'Password', true, PasswordValidatorType.BASIC);
		this.createForm();
		this.loading = false;
	}

	createForm() {
		this.form = this.fb.group({
			phone: this.phoneNumber.getFormGroupControl(),
			password: this.password.getFormGroupControl()
		});
	}

	submit() {
		const otpFormData = this.businessService.getData();
		// otpFormData.phoneNumber = this.form.value.phone
		otpFormData.password = this.form.value.password;
		const kycRoute: OTPCreationRoute = {
			key: 'PHONE_SELECTOR',
			route: 'pin/phone-selector',
			completed: true,
		};
		this.businessService.updateKycRoute(kycRoute);
		this.businessService.navigateKYCForm();
		this.businessService.saveData(otpFormData);
		// this.router.navigateByUrl('pin/business-pin')
	}

}
